var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:[
    'dg-sidebar-menu',
    {
      active: _vm.sidebarMenuVisibility,
    },
  ]},[_c('div',{staticClass:"dg-sidebar-menu__container"},[_c('ul',{staticClass:"menu-items"},_vm._l((_vm.items),function(item,index){return _c('MenuItem',{key:index,attrs:{"menu":item},on:{"linkClicked":_vm.linkClick}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }